import { render, staticRenderFns } from "./BrowseList.vue?vue&type=template&id=bf654dd6&scoped=true&"
import script from "./BrowseList.vue?vue&type=script&lang=js&"
export * from "./BrowseList.vue?vue&type=script&lang=js&"
import style0 from "./BrowseList.vue?vue&type=style&index=0&id=bf654dd6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf654dd6",
  null
  
)

export default component.exports